
import { Component, OnInit, Injector, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from "@angular/common/http";
import {User} from '../../../models/user';
// import { DctBase } from 'src/app/shared/lib/base/base.component';
import { SessionHelper } from '../../shared/services/localstorage';
import {LoginService} from '../../../globalservices/login.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public show: boolean = false;
  User:User;
  public log: boolean = true;
  userObj:any;
  dialog_disable: boolean = false;
  loginForm: FormGroup;
  isSubmitted:boolean = false;
  isLoading:boolean = false;
  errorMessage:string = ""
  constructor(
    
  public router: Router,
  public loginService:LoginService,
  public _formBuilder: FormBuilder,
    Injector: Injector,
   
  ) {
    this.User= new User();
    this.loginForm = this._formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
    
  }

  ngOnInit() {
   
    if(SessionHelper.isLoggedIn()){
      this.loginService.changeStatus(true);
     this.router.navigate(['dashboard']);
    }else{
      console.log("SessionHelper.isLoggedIn()",SessionHelper.isLoggedIn());
      this.loginService.changeStatus(false);
    }
  }
  hasError = (controlName: string, errorName: string) => {
    return this.loginForm.controls[controlName].hasError(errorName);
  }
  onLogin() {
   
    this.isSubmitted = true;
    
    if (this.loginForm.valid) {
      let model = this.loginForm.value;
      let reqData = {
        user: model.username,
        pwd: model.password
      }
      // this.isLoading=true
      this.loginService.getLogin(reqData)
      .subscribe((result:User)=>{
        // this.isLoading=false;
        console.log("result.result",result);
        if (result.data) {
          console.log("result.data",result.data);
          let apiResponse = result["data"];
          SessionHelper.setSession(apiResponse)
          console.log("Session ", SessionHelper.getSession(), SessionHelper.isLoggedIn());
          // this.router.navigate(['/speaker/dashboard']);
          console.log("apiResponse",apiResponse);
          if (apiResponse.key == "SPEAKER") {
            if(apiResponse.profile_image!='' && apiResponse.profile_image!=null){
              localStorage.setItem('profileUrl',apiResponse.profile_image);
              this.loginService.changeProfile(apiResponse.profile_image);
            }else{
             
              localStorage.setItem('profileUrl','assets/img/user-profile.png');
            }
            this.loginService.changeStatus(true);
            this.router.navigate(['dashboard']);
            // if ( apiResponse.UserCompanyBrandMapping.length > 1)
            //   this.router.navigate(['/speaker/selectbrands']);
            // else
            //   this.router.navigate(['/speaker/dashboard']);
          }
          // else if(apiResponse.user_type == "BADMIN"){
          //   this.router.navigate(['/brand-admin/dashboard']);
          // }
        }else{
          this.errorMessage = result.message ? result.message : "Invalid credentials"  
        }
      })
    } 
    // this.router.navigate(['speaker/dashboard']);
    // console.log("loginForm",this.loginForm.value);
  }
  setUserDetails(){
    this.userObj = SessionHelper.getSession();
  }
  onForgot(){
    // this.loginService.changeStatus(false);
    this.router.navigate(['forgot-password']);
  }
}
